import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { BModal } from 'bootstrap-vue';
import { Component, Inject, Ref, Prop } from 'vue-property-decorator';
import AlertService from '@/shared/alert/alert.service';
import { CatalogosApi } from '@conacyt/catalogos-client';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { Solicitud } from '@/shared/model/solicitud.model';
import { IHijos } from '@/shared/model/datosHijos.model';
import { CURP } from '@/shared/formatter/regex-utils';
import { TipoAccion } from '@/shared/model/enumerations/tipo-accion.model';
import ApeironComponent from '../commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { RenapoResourceApi } from '@conacyt/renapo-client';
import { Parentesco } from '@/shared/model/enumerations/parentesco';
import { TipoSolucion } from '@/shared/model/enumerations/tipo-solucion.model';
import { ICatalogoGenericoDto } from '@/shared/model/catalogoGenericoDto.model';
import { ICatalogoPaises } from '@/shared/model/catalogoPaises.model';
import { IInstitucionesMs } from '@/shared/model/seguimiento/instituciones-ms.model';
import { ICatalogoDto } from '@/shared/model/catalogoDto.model';
import { Filtro } from '@/shared/model/filtro.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';

const VALIDATIONS = function () {
  return {
    personaCurp: {
      comparecio: {
        required,
      },
      curp: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(20),
        CURP,
      },
      curpPareja: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(20),
        CURP,
      },
      nombres: {
        minLength: minLength(10),
        maxLength: maxLength(20),
      },
      apellidoPaterno: {
        minLength: minLength(10),
        maxLength: maxLength(20),
      },
      apellidoMaterno: {
        minLength: minLength(10),
        maxLength: maxLength(20),
      },
      genero: {
        minLength: minLength(10),
        maxLength: maxLength(20),
      },
      fechaNacimiento: {
        minLength: minLength(10),
        maxLength: maxLength(20),
      },
      paisNacimiento: {
        minLength: minLength(30),
        maxLength: maxLength(50),
      },
      parentesco: {
        minLength: minLength(10),
        maxLength: maxLength(20),
      },
    },
  };
};

@Component({
  validations: VALIDATIONS,
})
export default class DatosHijosExtComponent extends ApeironComponent {
  @Inject('alertService') public alertService: () => AlertService;
  @Inject('solicitudService') private solicitudService: () => SolicitudService;
  @Inject('renapoApi') private renapoApi: () => RenapoResourceApi;
  @Inject('catalogosApi') private catalogosApi: () => CatalogosApi;

  @Ref('confirmacionModal')
  public readonly confirmacionModal: BModal;

  @Ref('registroModal')
  public readonly registroModal: BModal;

  @Ref('eliminaHijoModal')
  public readonly eliminaHijoModal: BModal;

  @Prop({ required: false })
  public solicitud: Solicitud;

  @Prop({ default: null })
  public required: boolean;

  @Prop({ required: true })
  public readonly solucion: Solucion;

  public isFetching = false;
  form = this.solicitudModel;

  public totalItems = 0;
  public isSearching = false;
  public isSaving = false;
  public mensajeCarga: string = null;
  public indicadorCargaShow = false;
  public accion: string = null;
  public tituloModal: string = null;
  public mensajeConfirmacion: string = null;
  public descripcionActividad: string = null;
  public datosHijos: IHijos[];
  public inputCURPHijo = '';
  public inputCURPPareja = '';
  public isEdit = false;
  public requiredString = '';
  public placeholderBuscador = this.$t('apeironGwApp.datosHijos.buscador-curp.placeHolder');
  public placeholderBuscadorPareja = this.$t('apeironGwApp.datosHijos.buscador-curp.placeHolderPareja');
  public parentescoOptions = [];
  public erroresCURP = '';
  public existenErrores = false;
  public existeCurpHijo = false;
  public existeCurpPareja = false;
  public solicitudId = '';

  public catPaises: Array<ICatalogoGenericoDto> = [];
  public catInstituciones: Array<ICatalogoDto> = [];

  public personaCurp: IHijos = {
    curp: null,
    nombres: null,
    apellidoPaterno: null,
    apellidoMaterno: null,
    genero: null,
    fechaNacimiento: null,
    nacionalidad: null,
    parentesco: null,
    curpPareja: null,
    curpSolicitante: null,
    consecutivo: null,
    monto: null,
    divisa: null,
    paisNacimiento: null,
  };

  private get solicitudModel() {
    return {
      solicitud: {
        datosHijos: [],
      },
    };
  }

  public mounted() {
    this.parentescoOptions = Object.keys(Parentesco);
    this.initCatalogos();
  }

  private limpiaPersonaCurp() {
    this.personaCurp = {
      curp: null,
      nombres: null,
      apellidoPaterno: null,
      apellidoMaterno: null,
      genero: null,
      fechaNacimiento: null,
      nacionalidad: null,
      parentesco: null,
      curpPareja: null,
      curpSolicitante: null,
      consecutivo: null,
      monto: null,
      divisa: null,
      paisNacimiento: null,
    };
    this.inputCURPHijo = '';
    this.inputCURPPareja = '';
    this.existenErrores = false;
    this.erroresCURP = '';
  }

  /**
   * Realiza la búsqueda, validación y carga de información del CURP del hijo.
   *
   * Este método ejecuta las siguientes operaciones:
   *
   * - Reinicia los estados internos del componente.
   * - Valida el formato del CURP del hijo ingresado.
   * - Verifica si el hijo ya existe dentro de la solicitud actual.
   * - Consulta al backend para validar si el CURP ya está registrado en otras solicitudes activas.
   * - Consulta los datos del CURP de en RENAPO.
   * - Llena automáticamente los datos del hijo en `personaCurp`.
   * - Normaliza y verifica los apellidos del hijo contra los del solicitante y,
   *   si existe un CURP de pareja, también contra la pareja.
   * - Muestra mensajes de error cuando una validación falla y detiene el flujo.
   *
   * Este método no retorna información directa, pero modifica estados internos como:
   * - `personaCurp`: Datos poblados desde RENAPO.
   * - `solicitudId`: ID de una solicitud existente donde ya esté registrado el CURP.
   * - `isSearching`: Bandera de estado durante la búsqueda.
   *
   * También maneja internamente los errores HTTP provenientes de servicios externos.
   *
   * @returns Una promesa 'Promise' que se resuelve cuando el proceso ha sido completado.
   */
  public async buscarCURP(): Promise<void> {
    this.resetEstados();
    try {
      if (!this.validarCURP(this.inputCURPHijo)) {
        this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.curpHijo').toString());
        return;
      }

      const hijoDuplicado = this.solicitud.datosHijos?.some((hijo: any) => hijo.curp === this.inputCURPHijo);

      if (hijoDuplicado) {
        this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.solicitudHijo').toString());
        return;
      }

      const filtroSol = new Filtro();
      filtroSol.curpHijo = this.inputCURPHijo;
      const paginationQuery = {
        page: 0,
        size: 200,
        sort: 'asc.id',
        filter: filtroSol,
      };
      const solicitudes = await this.solicitudService().validaCurpSolicitudes(paginationQuery);

      if (solicitudes?.length) {
        const solicitudActiva = solicitudes.find(
          (s: any) => s.estado !== EstadoSolicitud.CANCELADA && s.estado !== EstadoSolicitud.FINALIZADA
        );

        if (solicitudActiva && solicitudActiva.beca.becario.cvu !== solicitudActiva.solicitante.cvu) {
          this.solicitudId = solicitudActiva.id;

          this.mostrarError(
            this.$t('apeironGwApp.datosHijos.errores.registroHijo', {
              solicitudId: this.solicitudId,
              nombre: solicitudActiva.solicitante.nombre,
              apellidoPaterno: solicitudActiva.solicitante.apellidoPaterno,
              apellidoMaterno: solicitudActiva.solicitante.apellidoMaterno,
              cvu: solicitudActiva.solicitante.cvu,
            }).toString()
          );
          this.isSearching = false;
          return;
        }
      }

      const renapoHijo = await this.renapoApi().getRenapoInternalUsingGET(this.inputCURPHijo);

      if (!renapoHijo?.data) {
        this.mostrarError('No se encontró el CURP del hijo en RENAPO');
        return;
      }

      const datosHijo = renapoHijo.data;

      this.personaCurp.curp = datosHijo.curp;
      this.personaCurp.nombres = datosHijo.nombres;
      this.personaCurp.apellidoPaterno = datosHijo.apellido1;
      this.personaCurp.apellidoMaterno = datosHijo.apellido2;
      this.personaCurp.genero = datosHijo.sexo;
      this.personaCurp.fechaNacimiento = datosHijo.fechNac;
      this.personaCurp.nacionalidad = datosHijo.nacionalidad;
      this.personaCurp.curpSolicitante = this.solicitud.solicitante.curp;

      const apellidosHijo = this.normalizarApellidos(datosHijo.apellido1, datosHijo.apellido2);

      const apellidosSolicitante = this.normalizarApellidos(
        this.solicitud.solicitante.apellidoPaterno,
        this.solicitud.solicitante.apellidoMaterno
      );

      if (this.inputCURPPareja) {
        if (!this.validarCURP(this.inputCURPPareja)) {
          this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.curpPareja').toString());
          return;
        }

        const renapoPareja = await this.renapoApi().getRenapoInternalUsingGET(this.inputCURPPareja);

        if (!renapoPareja?.data) {
          return this.mostrarError('No se encontró el CURP de la pareja en RENAPO');
        }
        const datosPareja = renapoPareja.data;

        const apellidosPareja = this.normalizarApellidos(datosPareja.apellido1, datosPareja.apellido2);

        const resultado = this.validarApellidos(apellidosHijo, apellidosSolicitante, apellidosPareja);

        if (resultado !== true) {
          return this.mostrarError(resultado);
        }
        this.personaCurp.curpPareja = this.inputCURPPareja;
      } else {
        const resultado = this.validarApellidos(apellidosHijo, apellidosSolicitante);

        if (resultado !== true) {
          return this.mostrarError(resultado);
        }
      }
      // Solo se activa guardado cuando Todo fue válido
      this.isSaving = true;
    } catch (err: any) {
      switch (err.response.status) {
        case 404:
          this.alertService().showError(this, err.response.data.detail);
          break;
        case 500:
          this.alertService().showError(this, this.$t('apeironGwApp.datosHijos.errores.servicios').toString());
          break;
        default:
          this.alertService().showHttpError(this, err.response);
      }
    } finally {
      this.isSearching = false;
    }
  }

  /**
   * Normaliza una lista de apellidos eliminando valores nulos, indefinidos o vacíos,
   * y estandarizando el formato (eliminando espacios y convirtiendo a mayúsculas).
   *
   * @param apellidos - Lista variable de apellidos a normalizar.
   * @returns Un arreglo de apellidos válidos, limpios y en mayúsculas.
   */
  private normalizarApellidos(...apellidos: (string | null | undefined)[]): string[] {
    return apellidos.filter(a => a && a.trim().length > 0).map(a => a!.trim().toUpperCase());
  }

  /**
   * Valida que los apellidos del hijo coincidan con los del solicitante
   * y opcionalmente con los de la pareja (si existe).
   *
   * - Si existe pareja, el hijo debe compartir al menos un apellido con cada uno.
   * - Si no existe pareja, debe compartir al menos un apellido con el solicitante.
   *
   * @param apellidosHijo - Apellidos normalizados del hijo.
   * @param apellidosSolicitante - Apellidos normalizados del solicitante.
   * @param apellidosPareja - (Opcional) Apellidos normalizados de la pareja.
   *
   * @returns `true` si la validación es correcta; de lo contrario,
   *          un `string` con el mensaje de error correspondiente.
   */
  private validarApellidos(apellidosHijo: string[], apellidosSolicitante: string[], apellidosPareja?: string[]): true | string {
    if (apellidosPareja && apellidosPareja.length > 0) {
      const coincideSolicitante = apellidosHijo.some(a => apellidosSolicitante.includes(a));
      const coincidePareja = apellidosHijo.some(a => apellidosPareja.includes(a));

      if (!coincideSolicitante || !coincidePareja) {
        return this.$t('apeironGwApp.datosHijos.errores.apellidosPadresHijo').toString();
      }
      return true;
    }

    const coincide = apellidosHijo.some(a => apellidosSolicitante.includes(a));

    if (!coincide) {
      return this.$t('apeironGwApp.datosHijos.errores.apellidosNoCoincidenSol', {
        apellidosSolicitante: apellidosSolicitante.join(' / '),
      }).toString();
    }

    return true;
  }

  /**
   * Reinicia los estados internos del componente relacionados con
   * la búsqueda y validación del CURP.
   *
   * Este método:
   * - Activa la bandera `isSearching`.
   * - Limpia mensajes de error.
   * - Reinicia indicadores de validación.
   */
  private resetEstados() {
    this.isSearching = true;
    this.isSaving = false;
    this.resetEstadosGuardado();
  }

  /**
   * Reinicia los estados internos del componente relacionados con
   * el guardado del curp.
   *
   * Este método:
   * - Limpia mensajes de error.
   * - Reinicia indicadores de validación.
   */
  private resetEstadosGuardado() {
    this.existenErrores = false;
    this.erroresCURP = '';
  }

  /**
   * Muestra un mensaje de error y actualiza los estados internos relacionados
   * con la visualización de errores y el proceso de búsqueda.
   *
   * Este método:
   * - Establece el mensaje de error en `erroresCURP`.
   * - Activa la bandera `existenErrores`.
   * - Detiene el indicador de búsqueda (`isSearching`).
   *
   * @param msg - Mensaje de error que se mostrará al usuario.
   */
  private mostrarError(msg: string) {
    this.erroresCURP = msg;
    this.existenErrores = true;
    this.isSearching = false;
  }
  /**
   * Obtiene los accesos permitidos en las acciones configurados en la solucion
   */
  get accesosSolucion(): any {
    return this.grantService().accesos(this.solucion, this.solicitud);
  }

  /**
   * Obtiene bandera para indicar de solo lectura basado en la accion de Escribir
   */
  get readOnly(): boolean {
    return this.accesosSolucion.acciones.findIndex(accion => accion === TipoAccion.ESCRIBIR) === -1;
  }

  /**
   * Valida si debe mostrar texto de Rubros Extranjeros
   */
  get isrubrosExt(): boolean {
    return this.solicitud?.beca?.solucionSolicitud?.tipoSolucion === TipoSolucion.BECAS_EXTRANJERAS;
  }

  public readonly fields = [
    {
      key: 'curp',
      label: this.$t('apeironGwApp.datosHijos.grid.curp'),
      class: 'text-left',
      thStyle: { width: '5rem' },
    },
    {
      key: 'nombres',
      label: this.$t('apeironGwApp.datosHijos.grid.nombres'),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'apellidoPaterno',
      label: this.$t('apeironGwApp.datosHijos.grid.apellidoPaterno'),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'apellidoMaterno',
      label: this.$t('apeironGwApp.datosHijos.grid.apellidoMaterno'),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'fechaNacimiento',
      label: this.$t('apeironGwApp.datosHijos.grid.fechaNacimiento'),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'monto',
      label: this.$t('apeironGwApp.datosHijos.grid.monto'),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'divisa',
      label: this.$t('apeironGwApp.datosHijos.grid.divisa'),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
  ];

  //:::: EVENTOS :::::
  public edit() {
    this.isEdit = !this.isEdit;
    this.$v.form.$touch();
    this.$v.busquedaInstitucion.$touch();
  }

  /**
   * Prepara el registro para eliminar Hijo
   */
  public eliminarHijo(): void {
    if (this.solicitud.datosHijos.length > 0) {
      this.solicitud.datosHijos.pop();
      this.solicitudService()
        .update(this.solicitud)
        .then(() => {
          this.alertService().showSuccess(this, 'apeironGwApp.datosHijos.mensajes.ultimoHijo');
          this.eliminaHijoModal.hide();
        })
        .catch(error => {
          this.alertService().showHttpError(this, error.response);
        });
    }
  }

  public guardarHijo() {
    this.resetEstadosGuardado();
    if (!this.solicitud.datosHijos) {
      this.solicitud.datosHijos = [];
    }

    if (!this.personaCurp.parentesco) {
      this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.parentesco').toString());
      return;
    }

    if (!this.existenErrores && !this.validarCURP(this.personaCurp.curp)) {
      this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.existenErrores').toString());
      return;
    }
    //Se agregan datos faltantes
    //Validación de rango de fechas
    const fechaInicio = new Date('2025-12-01'); // 1 diciembre 2025
    const fechaFin = new Date('2026-11-30'); // 30 noviembre 2026
    const fechaNacimiento = this.parseFechaDDMMYYYY(this.personaCurp.fechaNacimiento);
    const validaInicio = new Date(fechaNacimiento).getTime() >= new Date(fechaInicio).getTime();
    const validaFinal = new Date(fechaFin).getTime() >= new Date(fechaNacimiento).getTime();

    if (!(validaInicio && validaFinal)) {
      this.mostrarError('La fecha de nacimiento debe estar entre 1 diciembre 2025 al 30 noviembre 2026');
      return;
    }

    this.personaCurp.parentesco = this.personaCurp.parentesco;
    this.personaCurp.paisNacimiento = this.personaCurp.paisNacimiento;
    this.personaCurp.consecutivo = this.solicitud.datosHijos.length + 1;
    if (this.isrubrosExt) {
      this.personaCurp.monto = 43876.35;
      this.personaCurp.divisa = 'MXN';
    }
    this.solicitud.datosHijos.push(this.personaCurp);
    this.solicitud.nombreConvocatoria = this.solicitud.nombre;
    this.mensajeCarga = this.$t('indicadorCarga.guardando', {
      mensaje: this.$t('apeironGwApp.datosHijos.mensajes.actividad'),
    }).toString();
    this.indicadorCargaShow = true;
    this.solicitudService()
      .update(this.solicitud)
      .then(res => {
        this.alertService().showSuccess(this, this.$t('apeironGwApp.datosHijos.mensajes.guardadoExitoso').toString());
        this.cerrarModal();
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.indicadorCargaShow = false;
      });
    this.limpiaPersonaCurp();
  }

  public abrirModalAgregar(): void {
    this.limpiaPersonaCurp();
    this.mensajeCarga = this.$t('indicadorCarga.cargando', {
      mensaje: this.$t('apeironGwApp.datosHijos.mensajes.pantalla'),
    }).toString();
    this.indicadorCargaShow = true;
    this.accion = 'A';
    this.tituloModal = this.$t('apeironGwApp.datosHijos.modal.title.agregar').toString();
    this.registroModal.show();
    this.indicadorCargaShow = false;
  }

  public abrirModalEliminar() {
    this.eliminaHijoModal.show();
    this.accion = 'E';
    this.tituloModal = this.$t('apeironGwApp.datosHijos.modal.title.eliminar').toString();
  }

  public cerrarModal() {
    this.registroModal.hide();
    this.accion = null;
  }

  public abrirModalConfirmacion() {}

  public cerrarModalConfirmacion() {
    this.confirmacionModal.hide();
  }

  public cerrarModalConfirmacionEliminar() {
    this.eliminaHijoModal.hide();
  }

  public get buttonText() {
    switch (this.accion) {
      case 'A':
        return this.$t('apeironGwApp.cronogramaActividades.modal.boton.guardar');
      default:
        return null;
    }
  }

  public get buttonIcon() {
    switch (this.accion) {
      case 'A':
        return 'icon-guardar';
      default:
        return null;
    }
  }

  private validarFechas() {
    if ('E' === this.accion) {
      return true;
    }

    return true;
  }

  public initCatalogos() {
    this.getAllPaises().then((listaPaisTotal: ICatalogoPaises[]) => {
      this.catPaises = listaPaisTotal;
    });
  }

  onChangePais(clavePais: string) {
    this.getInstitucionesByPais(clavePais).then((listaInstTotal: IInstitucionesMs[]) => {
      this.catInstituciones = listaInstTotal;
    });
  }

  public aceptarConfirmacion() {
    switch (this.accion) {
      case 'A':
        this.guardarHijo();
        break;
      default:
        break;
    }
  }

  /**
   * Busca la solicitud.
   */
  public buscarSolucitud() {
    this.isFetching = true;
    this.solicitudService()
      .find(this.solicitud.id)
      .then(
        res => {
          this.form.solicitud = { ...res, ...JSON.parse(JSON.stringify(res)) };
          this.isFetching = false;
        },
        err => {
          this.isFetching = false;
        }
      );
  }

  /**
   * Consulta catálogo completo de paises
   *
   * @param pagina
   * @param catalogo en esquema {value: clavePais, text: nombre}
   * @returns
   */
  public async getAllPaises(pagina = 1, catalogo = []): Promise<any[]> {
    let total = 0;
    try {
      const res = await this.catalogosApi().getAllPaises(pagina, 100);

      if (res['headers']['x-total-pages'] && total == 0) {
        total = Number(res['headers']['x-total-pages']);
      }

      if (pagina === 1) {
        catalogo = res['data'];
      } else {
        catalogo = catalogo.concat(res['data']);
      }

      if (pagina >= total) {
        total = 0;
        catalogo.push({
          id: '65fa06c55810c04c72fd6db4',
          clave: 'MEX',
          nombre: 'México',
          nombreEsp: 'México',
          nombreIng: 'Mexico',
          divisa: 'MXN',
          nombreDivisa: '',
          rubros: {},
          version: '2025-01',
          activo: true,
          region: 'resto_mundo',
        });

        catalogo.sort((a, b) => a.nombreEsp.localeCompare(b.nombreEsp));
        return this.itemsAsOptions(catalogo, item => item.nombreEsp);
      }

      pagina++;
      return this.getAllPaises(pagina, catalogo);
    } catch (err) {
      if (err?.response?.data?.detail) {
        this.alertService().showError(this, err.response.data.detail);
      } else {
        this.alertService().showError(this, this.$t('error.internalServerError').toString());
      }
      return [];
    }
  }

  /**
   * Consulta catálogo completo de instituciones de un pais
   *
   * @param clavePais
   * @param pagina
   * @param catalogo en esquema {value: id, text: nombre}
   * @returns
   */
  public async getInstitucionesByPais(clavePais: string, pagina = 1, catalogo = []): Promise<any[]> {
    let total = 0;
    try {
      const res = await this.catalogosApi().getInstitucionesByPais(clavePais, pagina, 100);

      if (res['headers']['x-total-pages'] && total == 0) {
        total = Number(res['headers']['x-total-pages']);
      }

      if (pagina === 1) {
        catalogo = res['data'];
      } else {
        catalogo = catalogo.concat(res['data']);
      }

      if (pagina >= total) {
        total = 0;
        return this.itemsAsOptions(catalogo, item => item.id);
      }

      pagina++;
      return await this.getInstitucionesByPais(clavePais, pagina, catalogo);
    } catch (err) {
      if (err?.response?.data?.detail) {
        this.alertService().showError(this, err.response.data.detail);
      } else {
        this.alertService().showError(this, this.$t('error.internalServerError').toString());
      }
      return [];
    }
  }

  /**
   * Convierte listado de opciones a un esquema {value,text} para utilizar en componentes de
   * selección.
   * El value puede ser determinado desde la llamada al método para poder asignar de forma dinámica
   * un objeto o atributo deseado
   *
   * @param items listado de opciones
   * @param determinaValue método que determina el valor a utilizar
   * @returns listo en esquema {value,text}
   */
  itemsAsOptions(items: any[], determinaValue: (item: any) => any): any[] {
    return items.map(item => {
      return {
        value: determinaValue(item),
        text: item.nombre,
        disabled: false,
      };
    });
  }

  public parseFechaDDMMYYYY(fechaStr: string): Date {
    const [dia, mes, anio] = fechaStr.split('/').map(Number);
    return new Date(anio, mes - 1, dia); // mes inicia en 0
  }

  /**
  *
  * | Sección                | Significado                           |         |       |                      |
    | ---------------------- | ------------------------------------- | ------- | ----- | -------------------- |
    | `[A-Z]{1}`             | Inicial del primer apellido           |         |       |                      |
    | `[AEIOU]{1}`           | Primera vocal interna                 |         |       |                      |
    | `[A-Z]{2}`             | Inicial del segundo apellido y nombre |         |       |                      |
    | `\d{2}`                | Año de nacimiento                     |         |       |                      |
    | `(0[1-9]               | 1[0-2])`                              | Mes     |       |                      |
    | `(0[1-9]               | [12]\d                                | 3[01])` | Día   |                      |
    | `[HM]`                 | Sexo                                  |         |       |                      |
    | `(AS                   | BC                                    | BS      | ...)` | Estado de nacimiento |
    | `[B-DF-HJ-NP-TV-Z]{3}` | Consonantes internas                  |         |       |                      |
    | `[0-9A-Z]`             | Dígito diferenciador (homonimia)      |         |       |                      |
    | `\d`                   | Dígito verificador                    |         |       |                      |
   * @param curp CURP a validar
   * @returns Retorna true si el CURP cumple con el patrón, de lo contrario retorna false
   */
  private validarCURP(curp: string): boolean {
    const regexCURP =
      /^[A-Z]{1}[AEIOU]{1}[A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[HM](AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]\d$/;
    return regexCURP.test(curp);
  }
}
